export default {
  data() {
    return {
      breadcrumb: [
        { label: 'Quản lí users', path: '/users' }
      ],
      checkedlist: [],
      filter: {
        q: '',
        team: '',
        per_page: 50,
        page: 1
      },
      result: null,
      lockedMessage: '',
      crudForm: this.defaultCrudForm(),
      isSearching: false,
    }
  },

  computed: {
    master() {
      return this.$store.state.master;
    },

    countFilter(){
      let count = 0;
      if (this.filter.team) count++;
      return count;
    },
  },

  methods: {
    checkall() {
      if (this.checkedlist.length == this.result.data.length) this.checkedlist = [];
      else this.checkedlist = this.result.data.map((item) => item.id);
    },

    toggleCheckbox(id) {
      if (this.checkedlist.includes(id)) this.checkedlist.splice(this.checkedlist.indexOf(id), 1);
      else this.checkedlist.push(id);
    },

    defaultCrudForm() {
      return {
        id: 0,
        name: '',
        email: '',
        password: '',
        is_admin: false,
        role: '',
        team_id: null,
        errors: {}
      };
    },

    async search() {
      this.checkedlist = [];
      this.isSearching = true;
      let res = await this.$api.user.search(this.filter).call();
      this.isSearching = false;

      if (res.success) {
        this.result = res.response.result;
      }
    },

    resetFilter(){
      this.filter = {
        ...this.filter,
        team: null
      };
      this.onChangePage(1);
    },

    onChangeFilter(name, e, options){
      console.log(name, e, options);
      this.onChangePage(1);
    },

    // openModalReason() {
    //   this.$refs.lockedReson.show();
    // },

    // onLocked() {
    //   this.updateStatus('locked');
    //   this.$refs.lockedReson.hide();
    // },

    // onUnlock() {
    //   this.$store.dispatch('confirmation/open', {
    //     title: 'Confirm',
    //     message: 'Unlock account?',
    //     options: [
    //       {
    //         name: 'cancel',
    //         label: 'Cancel',
    //         variant: 'secondary'
    //       },
    //       {
    //         name: 'ok',
    //         label: 'OK',
    //         variant: 'primary'
    //       }
    //     ],
    //     events: {
    //       confirm: async (name) => {
    //         if (name == 'ok') {
    //           this.updateStatus('active');
    //         }
    //       }
    //     }
    //   });
    // },

    // async updateStatus(status) {
    //   let res = await this.$aloop.account.user.updateStatus({
    //     objects: this.checkedlist,
    //     message: this.lockedMessage,
    //     status: status
    //   }).call();

    //   if (res.success) {
    //     this.result.data.forEach((a) => {
    //       if (this.checkedlist.includes(a.id)) a.status = status;
    //     });
    //   }
    // },

    onChangeIsAdmin(){
      if (this.crudForm.is_admin) {
        this.crudForm.team_id = null;
        this.crudForm.role = null;
      }
    },

    openModalCreate() {
      this.crudForm = this.defaultCrudForm();
      this.$refs.crudModal.show();
    },

    openModalUpdate(data) {
      this.crudForm = this.defaultCrudForm();
      this.crudForm.id = data.id;
      this.crudForm.name = data.name;
      this.crudForm.email = data.email;
      this.crudForm.is_admin = data.is_admin;
      this.crudForm.role = data.role;
      this.crudForm.team_id = data.team_id;
      this.$refs.crudModal.show();
    },

    async onSaveCrud(){
      let req;
      let data = {...this.crudForm };
      delete data.errors;

      if (data.id) req = this.$api.user.update(data);
      else req = this.$api.user.create(data);
      let res = await req.call();

      if (res.success) {
        this.search();
        this.$refs.crudModal.hide();
      } else {
        if (res?.response?.result?.errors) this.crudForm.errors = res.response.result.errors;
      }
    },

    onRandomPassword() {
      var length = 8,
        charset = "abcdefghijklmnopqrstuvwxyzABCDEFGHIJKLMNOPQRSTUVWXYZ0123456789",
        retVal = "";
      for (var i = 0, n = charset.length; i < length; ++i) {
          retVal += charset.charAt(Math.floor(Math.random() * n));
      }

      this.crudForm.password = retVal;
    },

    onChangePage(page){
      this.filter.page = page;
      this.search();
    },

    onConfirmRemove2Fa(account){
      this.$store.dispatch('confirmation/open', {
          title: 'Xác nhận',
          type: 'confirmation',
          message: '<div>Bạn có chắc muốn xóa xác thực 2-FA của tài khoản này?</div><div>Tài khoản: <span class="text-danger">'+account.email+'</span></div>',
          options: [
            {
              name: 'cancel',
              label: 'Hủy',
              variant: 'secondary'
            },
            {
              name: 'ok',
              label: 'Xóa',
              variant: 'danger'
            }
          ],
          events: {
            confirm: async (name) => {
              if (name == 'ok') {
                let res = await this.$api.user.clearTwoFactor({
                  id: account.id
                }).call();
                if (res.success) account.two_factor_confirmed_at = null;
              }
            }
          }
        });
    },

    async onDelete() {
      this.$store.dispatch("confirmation/open", {
        title: "Xác nhận",
        type: 'confirmation',
        message: "Bạn thực sự muốn xóa "+this.checkedlist.length+" users được chọn?",
        options: [
          {
            name: "cancel",
            label: "Hủy",
            variant: "secondary",
          },
          {
            name: "delete",
            label: "Xóa",
            variant: "danger"
          },
        ],
        events: {
          confirm: async (name) => {
            if (name == 'delete') {
              let res = await this.$api.user.delete({id: this.checkedlist}).call();

              if (res.success) {
                this.checkedlist = [];
                this.search();
              }
            }
          }
        }
      });
    },
  },

  mounted() {
    this.search();
  }
}